export const WEEK_IN_MS = 7 * 24 * 60 * 60 * 1000;

export function clampWeek(week: number, minWeek: number, maxWeek: number): number {
  return Math.max(minWeek, Math.min(maxWeek, week));
}

export function weekToDate(weekNumber: number): Date {
  return new Date(Date.now() + weekNumber * WEEK_IN_MS);
}

export function formatWeekDate(weekNumber: number, locale?: string): string {
  return weekToDate(weekNumber).toLocaleDateString(locale, { year: 'numeric', month: 'short', day: 'numeric' });
}
